import { SvgProps } from "./Form";

export const CopyIcon = (props: SvgProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_5539_2063)">
        <path
          d="M12 12H2V3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2H10.5C10.8978 2 11.2794 2.15804 11.5607 2.43934C11.842 2.72064 12 3.10218 12 3.5V12ZM3 11H11V3.5C11 3.36739 10.9473 3.24021 10.8536 3.14645C10.7598 3.05268 10.6326 3 10.5 3H3.5C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24021 3 3.36739 3 3.5V11ZM13 4.092V13H4V14H14V5.5C13.9987 5.19087 13.902 4.88969 13.723 4.63765C13.544 4.38562 13.2915 4.19504 13 4.092Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_5539_2063">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
